import React from 'react'
import { getFirstWeekSlots } from '../../../../../../../Modules/Calendar/Helpers/Calendar'
import date from 'date-and-time'
import Button from '../../../../../../../Components/Buttons/Button'

const RequestedEnrollment = ({
  pendingEnrollmentRequest,
  deleteRegistration,
}) => {
  return (
    <div className='pendingEnrollmentRequest'>
      <h1>You have already sent an enrollment request for this course.</h1>

      <h2>You can cancel this request to send another.</h2>
      <div className='pendingRequestInfo'>
        <h2>Requested Slots </h2>
        <p>
          {getFirstWeekSlots(pendingEnrollmentRequest.dateSlots).map(
            (slot, i) => (
              <span key={'calendarSlotsForEnrollment' + i}>
                {date
                  .format(new Date(slot.startTime), 'dddd: hh:mm A - ')
                  .toUpperCase()}
                {date.format(new Date(slot.endTime), 'hh:mm A').toUpperCase()}
              </span>
            ),
          )}
        </p>
      </div>
      <Button
        onClick={() => deleteRegistration(pendingEnrollmentRequest.id)}
        name={'Cancel Request'}
        type={'primary'}
      />
    </div>
  )
}

export default RequestedEnrollment
